import DatabasePage from './DatabasePage';

export default DatabasePage;
